import { DotThemeValues } from '../../dots/dot.styles';
import { CriticalDot } from '../../dots/variants/critical-dot.component';
import { NeutralDot } from '../../dots/variants/neutral-dot.component';
import { PrimaryDot } from '../../dots/variants/primary-dot.component';
import { SuccessDot } from '../../dots/variants/success-dot.component';
import { WarningDot } from '../../dots/variants/warning-dot.component';

enum HoverTexts {
  Critical = 'Message failed to send',
  Warning = 'Message has not been responded to',
  Primary = 'Unread',
}

export const AvatarDot = ({ variant, hoverText }: { variant: keyof DotThemeValues; hoverText?: string }) => {
  const Dots = {
    critical: <CriticalDot hoverText={hoverText ?? HoverTexts.Critical} />,
    primary: <PrimaryDot hoverText={hoverText ?? HoverTexts.Primary} />,
    success: <SuccessDot hoverText={hoverText} />,
    warning: <WarningDot hoverText={hoverText ?? HoverTexts.Warning} />,
    neutral: <NeutralDot hoverText={hoverText} />,
  };

  return <span id='avatar-dot'>{Dots[variant]}</span>;
};
